import { render, staticRenderFns } from "./PrizesUpdate.vue?vue&type=template&id=75b1a38c"
import script from "./PrizesUpdate.vue?vue&type=script&lang=js"
export * from "./PrizesUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports